import {
  ADD_COURSE_FAILURE,
  ADD_COURSE_REQUEST,
  ADD_COURSE_SUCCESS,
  GET_COMPLETE_COURSE_DETAIL_FAILURE,
  GET_COMPLETE_COURSE_DETAIL_REQUEST,
  GET_COMPLETE_COURSE_DETAIL_SUCCESS,
  GET_COURSES_FAILURE,
  GET_COURSES_REQUEST,
  GET_COURSES_SUCCESS,
  GET_COURSE_BY_ID_FAILURE,
  GET_COURSE_BY_ID_REQUEST,
  GET_COURSE_BY_ID_SUCCESS,
  GET_COURSE_NESTED_DETAIL_FAILURE,
  GET_COURSE_NESTED_DETAIL_REQUEST,
  GET_COURSE_NESTED_DETAIL_SUCCESS,
  GET_MY_COURSES_FAILURE,
  GET_MY_COURSES_REQUEST,
  GET_MY_COURSES_SUCCESS,
  GET_MY_LEARNING_FAILURE,
  GET_MY_LEARNING_REQUEST,
  GET_MY_LEARNING_SUCCESS,
  RESET_COURSE_APPROVAL_STATUS,
  UPDATE_COURSE_APPROVAL_STATUS_FAILURE,
  UPDATE_COURSE_APPROVAL_STATUS_REQUEST,
  UPDATE_COURSE_APPROVAL_STATUS_SUCCESS,
  GET_BASIC_COURSE_DETAIL_FAILURE,
  GET_BASIC_COURSE_DETAIL_REQUEST,
  GET_BASIC_COURSE_DETAIL_SUCCESS,
  UPDATE_COURSE_FAILURE,
  UPDATE_COURSE_REQUEST,
  UPDATE_COURSE_SUCCESS,
  SEARCH_APPROVED_COURSES_FAILURE,
  SEARCH_APPROVED_COURSES_REQUEST,
  SEARCH_APPROVED_COURSES_SUCCESS,
  GET_PUBLIC_COURSE_COMPLETE_DETAIL_FAILURE,
  GET_PUBLIC_COURSE_COMPLETE_DETAIL_REQUEST,
  GET_PUBLIC_COURSE_COMPLETE_DETAIL_SUCCESS,
} from "./ActionType";

const initialState = {
  course: null,
  courseListResponse: null,
  approvalStatusChangeResponse: null,
  courseNestedDetail: null,
  basicCourseDetail: null,
  isLoading: false,
  error: null,
};
export const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_COURSE_REQUEST:
    case GET_COURSES_REQUEST:
    case GET_COURSE_NESTED_DETAIL_REQUEST:
    case UPDATE_COURSE_APPROVAL_STATUS_REQUEST:
    case GET_COMPLETE_COURSE_DETAIL_REQUEST:
    case GET_COURSE_BY_ID_REQUEST:
    case GET_MY_COURSES_REQUEST:
    case GET_MY_LEARNING_REQUEST:
    case GET_BASIC_COURSE_DETAIL_REQUEST:
    case UPDATE_COURSE_REQUEST:
    case SEARCH_APPROVED_COURSES_REQUEST:
    case GET_PUBLIC_COURSE_COMPLETE_DETAIL_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case ADD_COURSE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        course: action.payload,
      };
    case ADD_COURSE_FAILURE:
    case GET_COURSES_FAILURE:
    case GET_COURSE_NESTED_DETAIL_FAILURE:
    case UPDATE_COURSE_APPROVAL_STATUS_FAILURE:
    case GET_COMPLETE_COURSE_DETAIL_FAILURE:
    case GET_COURSE_BY_ID_FAILURE:
    case GET_MY_COURSES_FAILURE:
    case GET_MY_LEARNING_FAILURE:
    case GET_BASIC_COURSE_DETAIL_FAILURE:
    case UPDATE_COURSE_FAILURE:
    case SEARCH_APPROVED_COURSES_FAILURE:
    case GET_PUBLIC_COURSE_COMPLETE_DETAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case GET_COURSES_SUCCESS:
    case SEARCH_APPROVED_COURSES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        courseListResponse: action.payload,
      };
    case GET_COURSE_NESTED_DETAIL_SUCCESS:
    case GET_PUBLIC_COURSE_COMPLETE_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        courseNestedDetail: action.payload,
      };
    case UPDATE_COURSE_APPROVAL_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        approvalStatusChangeResponse: action.payload,
      };
    case RESET_COURSE_APPROVAL_STATUS:
      return {
        ...state,
        approvalStatusChangeResponse: null,
      };
    case GET_COMPLETE_COURSE_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        course: action.payload,
      };

    case GET_COURSE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        course: action.payload,
      };
    case GET_MY_COURSES_SUCCESS:
    case GET_MY_LEARNING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        courseListResponse: action.payload,
      };
    case GET_BASIC_COURSE_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        basicCourseDetail: action.payload,
      };
    case UPDATE_COURSE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        course: action.payload,
      };

    default:
      return state;
  }
};
